/**
 * Where a user record is managed.
 */
export enum IdentityProvider {
  Internal = 'internal',
  /**
   * User record is managed by an external identity provider (e.g. Azure AD, Okta).
   */
  External = 'external',
}
